export enum ActivityTab {
  Overview = "overview",
  Matches = "matches",
  Interested = "interested",
  Shortlist = "shortlist",
  Roles = "roles",
  Vacancies = "vacancies",
  Feedback = "feedback",
  Economics = "economics",
  KPI = "kpi",
  History = "history"
}
